import React from 'react';
import PropTypes from 'prop-types';
import PopupWin from '../PopupWin';
import PopupButton from '../PopupButton';
import './ConfirmDeleteModal.scss';

const ConfirmDeleteModal = ({ visible, onClose, onConfirm, title, message, loading = false }) => {
	return (
		<PopupWin
			visible={visible}
			onClose={onClose}
			hideClose={false}
			title={title || 'Confirm Delete'}
			footer={
				<>
					<PopupButton
						variant="secondary"
						onClick={onClose}
						disabled={loading}
					>
						Cancel
					</PopupButton>
					<PopupButton
						variant="primary"
						onClick={onConfirm}
						loading={loading}
					>
						{loading ? 'Deleting...' : 'Delete'}
					</PopupButton>
				</>
			}
		>
			<div className="confirm-delete-content">
				<div className="warning-icon">
					<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
							stroke="#DC3545"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"/>
					</svg>
				</div>
				<p className="message">{message || 'Are you sure you want to delete this item? This action cannot be undone.'}</p>
			</div>
		</PopupWin>
	);
};

ConfirmDeleteModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	title: PropTypes.string,
	message: PropTypes.string,
	loading: PropTypes.bool
};

export default ConfirmDeleteModal; 